import { useQuery } from "@apollo/client";
import { MY_ASSISTANT_QUERY } from "../graphql/queries";
import type { MyAssistantQuery } from "../generated/graphql";

interface UseMyAssistantReturn {
  assistant: MyAssistantQuery["myAssistant"] | null;
  loading: boolean;
  error: Error | undefined;
}

export const useMyAssistant = (): UseMyAssistantReturn => {
  const { data, loading, error } = useQuery<MyAssistantQuery>(MY_ASSISTANT_QUERY, {
    errorPolicy: "all",
  });

  return {
    assistant: data?.myAssistant || null,
    loading,
    error,
  };
};